import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';
import { SelfServiceSchedule } from '~src/schedule/serverApi/types/SelfServiceSchedule';

import { LinkedTaskItem } from '../types/LinkedTaskItem';

export type UpdateLinkedTaskSelfServiceSchedulesParams = {
  readonly id: string; // ID of exising linked task we are updating
  readonly selfServiceSchedule: SelfServiceSchedule;
  readonly linkedTaskItems: LinkedTaskItem[];
}

export class UpdateLinkedTaskSelfServiceSchedulesRequest extends Request<UpdateLinkedTaskSelfServiceSchedulesParams, IEmptyResult> {
  constructor(params: UpdateLinkedTaskSelfServiceSchedulesParams) {
    super('updateLinkedTaskSelfServiceSchedules', params);
  }
}
